import './_product-collection-feature.scss';

export default () => {};
